import React, {useContext} from 'react';
import Image from '~/components/Dynamic/Image';
import { Link } from 'gatsby';
import renderLink from '~/utils/render-link';
import ChevronUp from '~/components/Icons/ChevronUp';
import TransContext from '~/contexts/TransContext';

export default function StoryPreview({ post }) {
  const trans = useContext(TransContext);
  return post?.full_slug ? (
    <Link to={renderLink(`${post?.full_slug}`)} className="flex flex-col flex-auto group">
      <div className="mb-8 overflow-hidden">
        <div className="w-full bg-light-grey aspect-w-54 aspect-h-30">
          <div>
            <Image
              blok={post.previewImage}
              imageClassName="h-full w-full object-cover"
              className="object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
      <div className="mb-4 overflow-hidden md:mb-8">
        <div className="h-[25px] inline-block max-w-[11rem]">
          <Image blok={post.logo} imageClassName="h-full !w-auto object-contain" className="object-contain h-full" />
        </div>
      </div>
      <div className="flex flex-col flex-auto ">
        <div className="flex-auto">
          <div className="mb-4 overflow-hidden md:mb-8">
            <h4 className="text-h4">{post?.content?.previewTitle || post.name}</h4>
          </div>
        </div>
        <div>
          <h4 className="relative flex items-center mb-8 font-bold uppercase text-16px">
            {trans?.content?.readFullStory}
            <div className="inline-block ml-2 transition-transform transform rotate-90 group-hover:translate-x-1">
              <ChevronUp />
            </div>
          </h4>
        </div>
        <div className="border-t border-black"></div>
      </div>
    </Link>
  ) : null;
}
